/**
 * Opening the support chat the app already runs.
 *
 * `ChatwootWidget` (mounted once in main.tsx) loads the Chatwoot SDK and hangs
 * it on `window.$chatwoot`. Chatwoot's own floating bubble is hidden
 * (`hideMessageBubble`), so `SupportChatButton` in the application header is the
 * single launcher (MPE-1224).
 *
 * Not exposed inside Campaign Creation: that flow is a full-screen modal and
 * Chatwoot mounts outside it, so the chat window would open behind the overlay
 * and could not be used.
 */

/**
 * Flip the support chat between open and closed.
 *
 * `toggle()` with no argument lets Chatwoot flip its own state, which is the
 * only way our launcher and Chatwoot's own close control can stay in agreement.
 * Tracking open/closed in React instead would desynchronise the moment a user
 * closed the window from inside it — the exact failure manual QA hit, where the
 * widget could be opened but not reliably closed again.
 *
 * Returns whether the SDK was reached, so a caller can fall back. Never throws:
 * the SDK is absent whenever `VITE_CHATWOOT_WEBSITE_TOKEN` /
 * `VITE_CHATWOOT_BASE_URL` are unset — which is the case in local development —
 * and a support control must not be able to take down the page it sits on.
 */
export function toggleSupportChat(): boolean {
  try {
    if (!window.$chatwoot?.hasLoaded) return false
    if (typeof window.$chatwoot.toggle !== "function") return false
    window.$chatwoot.toggle()
    return true
  } catch {
    return false
  }
}
